/**
 * Bebida alcoólica (#243): textos e regras de exibição compartilhados.
 */

/** Aviso mostrado no pedido, na comanda e para o entregador */
export const ALCOHOL_DELIVERY_WARNING =
  'Contém bebida alcoólica: conferir documento com foto na entrega';

/** Nome do canal em que a maioridade foi confirmada */
export const AGE_CONFIRMATION_CHANNEL_LABELS: Record<string, string> = {
  STOREFRONT: 'loja virtual',
  TABLE: 'mesa (QR Code)',
  WHATSAPP: 'WhatsApp',
  PANEL: 'painel (atendente)',
};

/** O pedido tem bebida alcoólica (confirmação gravada ou item marcado) */
export function orderHasAlcohol(order: {
  hasAlcoholic?: boolean;
  ageConfirmedAt?: string | null;
  items?: Array<{ isAlcoholic?: boolean; product?: { isAlcoholic?: boolean } }>;
}): boolean {
  return !!(
    order.hasAlcoholic ||
    order.ageConfirmedAt ||
    order.items?.some(item => item.isAlcoholic || item.product?.isAlcoholic)
  );
}

/** Item do carrinho com bebida alcoólica: o produto ou algum sabor do meio a meio */
export function cartItemHasAlcohol(item: {
  product?: { isAlcoholic?: boolean } | null;
  flavors?: Array<{ isAlcoholic?: boolean }> | null;
}): boolean {
  return !!(item.product?.isAlcoholic || item.flavors?.some(flavor => flavor.isAlcoholic));
}
